export const localFiltersFields = Object.freeze({
  DANGEROUS_STATE_FILTERS: 'dangerousStateFilters',
  USER_STATE_FILTERS: 'userStateFilters'
})

export class CriticalEventLocalFilters {
  constructor ({ dangerousStateFilters = [], userStateFilters = [] } = {}) {
    this[localFiltersFields.DANGEROUS_STATE_FILTERS] = [...dangerousStateFilters]
    this[localFiltersFields.USER_STATE_FILTERS] = [...userStateFilters]
  }

  static getFields () {
    return Object.keys(new CriticalEventLocalFilters())
  }

  static criticalEventsMapping () {
    return {
      [localFiltersFields.DANGEROUS_STATE_FILTERS]: 'dangerousStateNormalized',
      [localFiltersFields.USER_STATE_FILTERS]: 'state'
    }
  }
}
